module.exports = __webpack_public_path__ + "assets/img/school1.ef5aec35.jpg";